import { CheckBadgeIcon, XMarkIcon } from "@heroicons/react/20/solid";
import {
  CardElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";
import Spinner from "../common/Spinner";

const CARD_OPTIONS = {
	hidePostalCode: true,
	iconStyle: "solid",
	style: {
		base: {
			"iconColor": "#666",
			"color": "#000",
			"fontWeight": 500,
			"fontFamily": "Open Sans, Segoe UI, sans-serif",
			"fontSize": "16px",
			"fontSmoothing": "antialiased",
			":-webkit-autofill": { color: "#666" },
			"::placeholder": { color: "#666" },
		},
		invalid: {
			iconColor: "red",
			color: "red",
		},
		valid: {
			iconColor: "green",
			color: "green",
		},
	},
};

const CheckoutForm = ({
	advisorCharge,
	businessDetails,
	selectedBundle,
	stripeCustomerID,
	paymentOptionsLength,
	stripeIntent,
	getStripeIntent,
	getStripePaymentMethods,
	clearBundle,
	cancelNewCard,
	setSavingCard,
	savingCard,
	hasPaymentMethods,
}) => {
	// const [sidebarOpen, setSidebarOpen] = useState(false)
	useEffect(() => {
		getStripeIntent(advisorCharge);
	}, [advisorCharge]);

	const stripe = useStripe();
	const elements = useElements();

	const handleSubmit = async (event) => {
		// Block native form submission.
		event.preventDefault();

		if (savingCard) return;

		if (!stripe || !elements) return;

		setSavingCard(true);

		// Get a reference to a mounted CardElement. Elements knows how
		// to find your CardElement because there can only ever be one of
		// each type of element.
		const cardElement = elements.getElement(CardElement);

		// Use your card Element with other Stripe.js APIs
		// const {error, paymentMethod} = await stripe.createPaymentMethod({
		//   type: 'card',
		//   card: cardElement,
		// });
		//
		const clientSecret = stripeIntent;

		const savedCard = await stripe.confirmCardSetup(clientSecret, {
			payment_method: {
				card: cardElement,
				// billing_details: {
				//   name: 'Jenny Rosen',
				// },
			},
		});

		console.log("savedCard", savedCard);

		// refresh payment methods
		setSavingCard(false);
		getStripePaymentMethods(advisorCharge);
	};

	return (
		<div className="col-sm-12 pl-0 pr-0 form-inner-box">
			<form>
				<div className="col-xs-12">
					<div
						style={{
							width: "100%",
							// maxWidth: "500px",
							background: "#fff",
							boxShadow: "0 1px 3px 0 rgba(50, 50, 93, 0.15), 0 4px 6px 0 rgba(112, 157, 199, 0.15)",
							borderRadius: "4px",
							padding: "10px",
							border: "none",
							fontSize: 0,
						}}
					>
						<CardElement options={CARD_OPTIONS} />
					</div>
					{/* <a className="pull-left"
            onClick={() => hasPaymentMethods ? cancelNewCard() : clearBundle()}
            style={{
              color: "#999",
              cursor: "pointer",
              border: "1px solid transparent"
            }}>
            Cancel
          </a> */}
				</div>
				<div className="col-xs-12 mt-10">
					<a
						className="btn btn-primary pull-right"
						onClick={handleSubmit}
					>
						{savingCard ? (
							<Spinner
								style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
								className="animate-spin -ml-1 mr-3 h-5 w-5 "
							/>
						) : (
							<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						)}
						<div style={{ float: "left" }}>{savingCard ? `Adding Card Details` : `Add Card`}</div>
					</a>
					{paymentOptionsLength && !savingCard ? (
						<div
							className="btn btn-default pull-right"
							style={{ marginRight: 10 }}
							onClick={() => (hasPaymentMethods ? cancelNewCard() : clearBundle())}
						>
							<XMarkIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Cancel</div>
						</div>
					) : null}
				</div>
				<div className="clearfix" />
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		paymentOptionsLength: state.payment?.stripe?.paymentMethods?.length > 0,
		businessDetails: state.payment?.stats?.businessDetails,
		selectedBundle: state.payment?.selectedBundle,
		stripeCustomerID: state.payment?.stats?.stripeCustomerID,
		savingCard: state.payment?.stripe?.savingCard,
		hasPaymentMethods: state.payment?.stripe?.paymentMethods?.length > 0,
		stripeIntent: state.payment?.stripe?.intent?.client_secret,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getStripeIntent: (advisorCharge) => dispatch(PAYMENTACTIONS.getStripeIntent(advisorCharge)),
	getStripePaymentMethods: (advisorCharge) => dispatch(PAYMENTACTIONS.getStripePaymentMethods(null,advisorCharge)),
	clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
	cancelNewCard: () => dispatch(PAYMENTACTIONS.addNewCard(false)),
	setSavingCard: (status) => dispatch(PAYMENTACTIONS.savingNewCard(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
